export * from './email.validator';
export * from './equalPasswords.validator';


// WEBPACK FOOTER //
// /app/src/app/theme/validators/index.ts